module.exports = __webpack_public_path__ + "static/ig_logo-26b65b3c69220aba6edc015a20be9519.jpeg";